import { BaseService } from './../base-service';
/* tslint:disable */
import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { ContentPage } from '../models/content-page';
import { ProxyService } from '@core/services';
import { LoggingService } from '@core/services/logging.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { HttpResponse } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../strict-http-response';
@Injectable({
  providedIn: 'root',
})
export class ContentPagesService implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    
  }
  ngOnInit(): void {
    
  }
  constructor(
    private proxy: ProxyService,
    private logger: LoggingService
  ) {
    
  }

  getContentPageBySlug(slug?: string): Observable<ContentPage> {
    return this.getContentPageBySlugResponse(slug).pipe(
      map(_r => _r.body as ContentPage)
    );
  }
  
  private getContentPageBySlugResponse(slug?: string): Observable<StrictHttpResponse<ContentPage>> {
    return this.proxy.httpGet(ApiRoutes.CONTENTPAGE + '?slugs='+slug).pipe(
      filter(_r => _r instanceof HttpResponse),
      map((_r) => {
        return _r as StrictHttpResponse<ContentPage>;
      })
    );
  }
}